module.exports = __webpack_public_path__ + "img/invoiceWriteAct.4f535ff6.png";